(() => {
  if (window.__SQ_UNIVERSAL_FAVORITES_ENGINE_GUARD__) return;
  window.__SQ_UNIVERSAL_FAVORITES_ENGINE_GUARD__ = true;

  const WRAPPER = '[data-sq-universal-favorites-source]';
  const TRIGGERS = '[data-lcs-universal-choose],[data-pick-quick-open],[data-sq-universal-expanded-open],[data-sq-home-featured-action="choose"]';

  const resetExpandedTriggers = () => {
    document.querySelectorAll(TRIGGERS).forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };

  const prune = async (wrapper) => {
    if (!(wrapper instanceof HTMLElement) || wrapper.dataset.sqEnginePruned === 'true') return;

    let page = wrapper.querySelector('[data-lcs-favorites-page]');
    let controller = page?.__lcsFavoritesPage || null;

    for (let attempt = 0; attempt < 240 && (!page || !controller); attempt += 1) {
      await new Promise((resolve) => requestAnimationFrame(resolve));
      page = wrapper.querySelector('[data-lcs-favorites-page]');
      controller = page?.__lcsFavoritesPage || null;
    }

    if (!page || !controller) return;

    wrapper.dataset.sqEnginePruned = 'true';
    page.dataset.sqUniversalEngineOnly = 'true';

    try { controller.observer?.disconnect?.(); } catch (_) {}
    controller.render = async () => {};
    controller.visibleCount = 0;

    const modal = page.querySelector('[data-lcs-favorite-expanded]');
    const notice = page.querySelector('[data-lcs-favorites-notice]');
    const selectionCard = page.querySelector('[data-lcs-favorites-selection-card]');

    if (controller.grid) controller.grid.replaceChildren();
    if (selectionCard) {
      [...selectionCard.children].forEach((child) => {
        if (child !== modal && child !== notice) child.remove();
      });
    }

    wrapper.querySelectorAll([
      '.sqyml2',
      '.sq-favorites-premium-slider',
      '[data-sq-favorites-premium-slider]',
      '[data-sq-premium-slider]',
      '.section-background'
    ].join(',')).forEach((node) => node.remove());

    if (notice) notice.hidden = true;
    if (modal?.hidden === false) controller.closeExpanded?.();
    if (modal) {
      new MutationObserver(() => {
        if (modal.hidden) resetExpandedTriggers();
      }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    }
  };

  const initialize = (scope = document) => {
    if (scope instanceof Element && scope.matches(WRAPPER)) void prune(scope);
    scope.querySelectorAll?.(WRAPPER).forEach((wrapper) => void prune(wrapper));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-lcs-expanded-close]')) {
      window.setTimeout(resetExpandedTriggers, 0);
    }
  }, true);

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
